import { useContext } from "react";
import { appsContainerTabContext } from "./apps-container-tab-context";

export const useAppsContainerTabContext = () =>
    useContext(appsContainerTabContext);
